<script setup lang="ts">
import { onMounted, ref, computed } from 'vue'
import { useGetDetailProduct } from '@/services/useGetDetailProduct'
import ProductComparsion from './_ProductComparsion.vue'
import ProductDetailHero from './_ProductDetailHero.vue'
import Product404 from './_Product404.vue'
import { PCSPageNames, setPageName } from '@/store/pageName'
import { useBuyforyou } from '@/lib/useBuyforyou'

const { isLoading, product, getProductData, loadMoreData, isShowMore } =
	useGetDetailProduct()
const { buyforyouWarehouses, fetchBuyforyouWarehouses } = useBuyforyou()

const searchParams = ref(new URLSearchParams(window.location.search))
const searchPayload = computed(() => ({
	sku: searchParams.value.get('id') || '',
	location: searchParams.value.get('location') || '',
}))

const isProductsEmpty = computed(() => !product.value?.products.length)

const handleLoadMoreData = () => {
	if (searchParams.value) {
		loadMoreData(searchPayload.value)
	}
}

/**
 * Checks the product and redirects accordingly.
 */
const checkProductAndRedirect = () => {
	if (searchPayload.value.sku) {
		getProductData(searchPayload.value)
	} else {
		console.error('Product ID is missing in the URL')
		// 如果 URL 中沒有 id，重導向到 PCS 首頁
		window.location.href = '/shop'
	}
}

onMounted(() => {
	setPageName(PCSPageNames.Detail)

	checkProductAndRedirect()
	fetchBuyforyouWarehouses()
})
</script>

<template>
	<template v-if="!isProductsEmpty">
		<section class="bg-white">
			<ProductDetailHero :product="product" />
		</section>
		<section>
			<ProductComparsion
				:product="product"
				@loadMoreData="handleLoadMoreData"
				:isShowMore="isShowMore"
				:isLoading="isLoading"
				:buyforyouWarehouses="buyforyouWarehouses"
			/>
		</section>
	</template>

	<Product404 v-if="product && isProductsEmpty" />
</template>
